import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {PostExamsRebook, PostExamsRebookParams, PostExamsRebookModel} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemotePostExamsRebook implements PostExamsRebook {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostExamsRebookModel>,
	) {}

	async post(params: PostExamsRebookParams): Promise<PostExamsRebookModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
